"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenUnionDeclaration = void 0;
const ramda_1 = require("ramda");
function flattenUnionDeclaration(declaration) {
    if (declaration.type === 'Union') {
        return ramda_1.uniq(declaration.declarations).flatMap((subDeclaration) => {
            if (subDeclaration.type === 'Union') {
                return flattenUnionDeclaration(subDeclaration);
            }
            return subDeclaration;
        });
    }
    return [declaration];
}
exports.flattenUnionDeclaration = flattenUnionDeclaration;
